module.exports = __webpack_public_path__ + "img/exportJson2.937cefe9.png";